// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_inputWrapper__t-YtK {
  max-width: 334px;
}
@media (max-width: 768px) {
  .styles_inputWrapper__t-YtK {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Stake/content/calculatorBlock/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AC6BE;ED7BF;IAII,eAAA;EAAF;AACF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n\n.inputWrapper {\n  max-width: 334px;\n\n  @include md {\n    max-width: 100%;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": `styles_inputWrapper__t-YtK`
};
export default ___CSS_LOADER_EXPORT___;
